import React from 'react'
import './TechnicalSpecs.scss'
import TechnicalIcon from './TechnicalIcon'

export default class TechnicalSpecs extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isVisible: false,
    }
  }

  getServices() {
    const projectServices = this.props.services
    if (projectServices) {
      const services = Object.keys(projectServices).map(function(
        service,
        index
      ) {
        if (
          projectServices[service] !== null &&
          projectServices[service] != 'false'
        ) {
          return (
            <li key={index}>
              <TechnicalIcon imageUrl={`${service}.png`} />
              <span className="service-title">
                {service.charAt(0).toUpperCase() + service.slice(1)}
              </span>
            </li>
          )
        }
      })
      return services
    }
  }

  _handleClick(e) {
    e.preventDefault()
    this.setState({
      isVisible: !this.state.isVisible,
    })
  }

  renderDropdown(services) {
    return <ul className="dropdown">{services}</ul>
  }

  render() {
    const services = this.getServices()
    if (services) {
      return (
        <div className="dropdown-wrapper">
          <button
            className="link"
            type="button"
            onClick={e => this._handleClick(e)}
            tabIndex="1"
            aria-expanded={this.state.isVisible}
          >
            {this.state.isVisible
              ? 'Hide technical specifications'
              : 'Show technical specifications'}{' '}
            <i className="fa fa-caret-right" aria-hidden="true"></i>
          </button>
          {this.state.isVisible ? this.renderDropdown(services) : null}
        </div>
      )
    } else return ''
  }
}
